(function () {
  const FEE_VARIANT_ID = 56907639292244;
  const THRESHOLD_CENTS = 2000;
  let busy = null;

  async function reconcile() {
    if (busy) return busy;
    busy = (async () => {
      const cartUrl = (typeof routes !== 'undefined' && routes?.cart_url) || '/cart';
      const updateUrl = (typeof routes !== 'undefined' && routes?.cart_update_url) || '/cart/update.js';
      const cartResponse = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) return false;
      const cart = await cartResponse.json();
      const regularSubtotal = cart.items
        .filter((item) => Number(item.variant_id) !== FEE_VARIANT_ID)
        .reduce((sum, item) => sum + Number(item.final_line_price || 0), 0);
      const feeQty = cart.items
        .filter((item) => Number(item.variant_id) === FEE_VARIANT_ID)
        .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      const wanted = regularSubtotal > 0 && regularSubtotal < THRESHOLD_CENTS ? 1 : 0;
      if (feeQty === wanted) return false;
      const response = await fetch(updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: { [FEE_VARIANT_ID]: wanted } }),
      });
      if (!response.ok) throw new Error('Small order fee update failed');
      const finalCart = await response.json();
      window.KKCartCountSync?.render(finalCart.item_count || 0);
      return true;
    })().finally(() => { busy = null; });
    return busy;
  }

  // Correct stale/test carts on page load. On the cart page reload once only if
  // a correction was actually necessary, so the rendered Liquid matches Shopify.
  document.addEventListener('DOMContentLoaded', async () => {
    try {
      const changed = await reconcile();
      if (changed && document.querySelector('cart-items')) location.reload();
    } catch (_) {}
  }, { once: true });

  // Product AJAX additions elsewhere in the theme publish cartUpdate. Reconcile
  // the fee in the background so the cart is already correct when opened.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event?.source === 'cart-items') return;
      reconcile().catch(() => {});
    });
  }

  // Final guard for the normal cart checkout button.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('#checkout');
    if (!button) return;
    event.preventDefault();
    button.disabled = true;
    try {
      const changed = await reconcile();
      if (changed) {
        location.reload();
        return;
      }
      const form = document.getElementById('cart');
      if (form) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        hidden.value = 'checkout';
        form.appendChild(hidden);
        form.submit();
      }
    } catch (_) {
      button.disabled = false;
    }
  }, true);
})();
